export const tabsTitles = [
  'Orders', 
  'Reviews', 
  'Transactions', 
  'Cart', 
  'Wishlist', 
  'Addresses',
  'Payments', 
  'About'
]

export const custHeaders = [
  {name: 'Customer #', val: 0},
  {name: 'Name', val: 1},
  {name: 'Email', val: 2},
  {name: 'Phone', val: 4},
  {name: 'City', val: 5},
  {name: 'Province/State', val: 6},
  {name: 'Country', val: 7},
  {name: 'Money Spent', val: 8},
  {name: 'Actions', val: -1}
]

export const reviewsHeaders = [
  {name: 'Review #', val: 0},
  {name: 'Review Title', val: 1},
  {name: 'Product Reviewed', val: 2},
  {name: 'Reviewer Name', val: 3},
  {name: 'Date Reviewed', val: 4},
  {name: 'Rating', val: 5},
  {name: 'Approved', val: -1},
  {name: 'Actions', val: -1}
]

export const custOrdHeaders = [
  'Order #',
  'Products',
  'Order Date',
  'Total',
  'Status'
]

export const custRevsHeaders = [
  'Title',
  'Product',
  'Date Reviewed',
  'Rating',
  'Likes'
]

export const custTransHeaders = [
  'Number',
  'Order #',
  'Card Number',
  'Method',
  'Date',
  'Total',
]

export const custCartHeaders = [
  'Product',
  'Name',
  'Style',
  'Unit Price',
  'Quantity',
  'Total',
]

export const custWishHeaders = [
  'Product',
  'Name',
  'Stock',
  'Unit Price',
]

export const custAddressHeaders = [
  'Name',
  'Address',
  'Postal Code',
  'City',
  'Region',
  'Country',
  'Primary'
]

export const custPaymentsHeaders = [
  'Card',
  'Card Number',
  'Cardholder',
  'Exp. Date',
  'Billing Address',
  'Bank',
  'Primary'
]

export const subsHeaders = [
  {name: 'Name', val: 0},
  {name: 'Email', val: 1},
  {name: 'Date Added', val: 2},
  {name: 'Status', val: 3},
  {name: 'Actions', val: -1}
]